import { useEffect, useState } from 'react';

const CONSULTA = '(max-width: 700px)';

// Uso: const esMovil = useEsMovil(); -- true en pantallas de celular (<=700px
// de ancho), para adaptar padding/columnas/tablas sin depender de CSS con
// media queries (todo el resto de la app usa estilos inline en JS).
export default function useEsMovil() {
  const [esMovil, setEsMovil] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(CONSULTA).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(CONSULTA);
    const actualizar = (e) => setEsMovil(e.matches);
    mq.addEventListener('change', actualizar);
    return () => mq.removeEventListener('change', actualizar);
  }, []);

  return esMovil;
}
